import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoginRequestPayload } from './interfaces/login-request-payload';
import { LoginResponsePayload } from './interfaces/login-response-payload';
import User from './models/user';
import USER_META from './constants';
import HttpPromiseService from '../core/services/http-promise/http-promise.service';
import GlobalStore from '../core/services/global-store/global.store';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export default class AuthenticationService {
  private http = inject(HttpPromiseService);

  private httpClient = inject(HttpClient);

  private router = inject(Router);

  private globalStore = inject(GlobalStore);

  public login(loginRequest: LoginRequestPayload): Observable<LoginResponsePayload> {
    return this.httpClient.post<LoginResponsePayload>('api/auth/token', loginRequest);
  }

  public isLoggedIn(): boolean {
    return !!localStorage.getItem(USER_META);
  }

  public logout(): void {
    this.globalStore.userLogout();
    this.router.navigate(['/authentication/login']);
  }

  public getUsers(): Promise<[User[], number]> {
    return this.http.get<[User[], number]>('/auth/users?page=1');
  }
}
